/* MultiEditAction.js */

"use strict";
const _ = require("lodash");
const warningVeil = require("./veil/WarningComponent");

class MultiEditAction {
    constructor(logger, gameEditor, activeView, steveIo, modalUserFeedback, StorageFactory) {
        this._logger = logger;
        this._activeView = activeView;
        this._modalUserFeedback = modalUserFeedback;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this._storageFactory = StorageFactory;
        this.run = this.run.bind(this);
    }
    run() {
        let selectedSiteIds = _.get(this._activeView.getSelectedSiteIds(), "selectedRows", []);
        const hasRoot = selectedSiteIds.find((id) => id === this._gameEditor._activeOrgId);
        this._userDataStorage = this._storageFactory.getRemoteStorageInstance(
            "view",
            "site_details"
        );
        if (hasRoot) {
            if (selectedSiteIds.length === 2) {
                const msg =
                    "The root site cannot be modified with Multi-Edit. Select at least two other sites to use Multi-Edit.";
                return this._modalUserFeedback.displayNotification(msg, {
                    title: "Multi-Edit Sites",
                    confirmDetails: {
                        text: "OK",
                        type: "text",
                    },
                });
            }
            selectedSiteIds = selectedSiteIds.filter((id) => id !== this._gameEditor._activeOrgId);
            const multiEditRootWarning = this._userDataStorage.getData(
                "Multiedit-Root-Warning",
                true
            );
            if (!multiEditRootWarning) {
                const component = new warningVeil(this._logger);
                return this._modalUserFeedback
                    .displayCustom(component)
                    .then((val) => {
                        this._userDataStorage.setData(val, "Multiedit-Root-Warning");
                    })
                    .finally(() => {
                        this._activeView.openSiteInstanceEditor(selectedSiteIds);
                    });
            }
        }
        this._activeView.openSiteInstanceEditor(selectedSiteIds);
    }
}
module.exports = MultiEditAction;

MultiEditAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.io",
    "$teve.ui.userFeedback",
    "$teve.storageFactory",
];

MultiEditAction.$displayDetails = {
    type: "Action",
    name: "MultiEditAction",
    icon: "common.multi_edit",
    shown: true,
    title: "Edit sites",
    order: 4,
};
